import { Box } from "@mui/material";
import { appBarHeight } from "../../appbar/AppBar";
import { colors } from "../../ui/colors";

interface AppsCenterLayoutProps {
  children: React.ReactNode;
}

export const AppsCenterLayout = ({ children }: AppsCenterLayoutProps) => {
  return (
    <Box>
      {children}
    </Box>
  );
};
